import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	FRAME_MEDIUM_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame27 = (props: TQrFrameProps) => {
	const { previewMode } = props

	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 69
		const boxHeight = 11
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				d="M60.5 14.5h-56l-.5 10 8 3L60 26z"
				fill={frameBackgroundColor}
			/>
			<path
				id="shadow"
				d="M25.963 30.617c-.563 0-1.05-.399-1.182-.968l-4.2-20.4a2.77 2.77 0 0 0-1.8-2.011l-7.856-2.676a1.205 1.205 0 0 1-.75-1.537c.206-.645.9-.987 1.519-.76l7.837 2.676c1.707.57 3 2.03 3.394 3.796v.019l4.219 20.38c.131.665-.281 1.31-.938 1.443-.093.019-.168.038-.244.038"
				fill={previewMode ? FRAME_MEDIUM_GREY : frameColor}
			/>
			{!previewMode ? (
				<path
					id="shadow"
					d="M25.963 30.617c-.563 0-1.05-.399-1.182-.968l-4.2-20.4a2.77 2.77 0 0 0-1.8-2.011l-7.856-2.676a1.205 1.205 0 0 1-.75-1.537c.206-.645.9-.987 1.519-.76l7.837 2.676c1.707.57 3 2.03 3.394 3.796v.019l4.219 20.38c.131.665-.281 1.31-.938 1.443-.093.019-.168.038-.244.038"
					fill="white"
					opacity={0.5}
				/>
			) : null}
			<g id="frame" fill={frameColor}>
				<path d="M55.119 19.534h.187a.1.1 0 0 0 .047-.01.1.1 0 0 1 .047-.009q.012 0 .025-.007c.013-.005.028-.012.05-.012q.016-.015.04-.022l.035-.016q.016-.013.038-.019a.1.1 0 0 0 .037-.018q.015-.015.038-.029l.037-.029.037-.028.038-.028a.3.3 0 0 0 .075-.057.3.3 0 0 1 .056-.076l.028-.038q.015-.023.029-.038l.028-.038q.013-.023.028-.038a.1.1 0 0 0 .022-.04l.015-.036q.013-.016.019-.038.007-.022.019-.038 0-.012.007-.025a.1.1 0 0 0 .011-.05c.02-.039.02-.058.02-.096v-.19a.1.1 0 0 0-.01-.047q-.009-.02-.01-.047l-.007-.025a.1.1 0 0 1-.011-.051.1.1 0 0 1-.022-.04l-.016-.036a.1.1 0 0 1-.018-.038.1.1 0 0 0-.02-.038l-.027-.038-.029-.038-.028-.038q-.013-.022-.028-.038a.3.3 0 0 0-.056-.076.9.9 0 0 0-.638-.265.9.9 0 0 0-.637.265q-.015.016-.028.038l-.028.038q-.015.016-.028.038l-.029.038-.028.038-.028.038a.1.1 0 0 0-.022.04l-.015.036a.1.1 0 0 0-.022.04l-.016.036q0 .012-.007.025a.1.1 0 0 0-.011.05c-.02.039-.02.058-.02.096v.19q.001.027.01.047t.01.047q0 .012.006.025.01.019.012.051a.1.1 0 0 1 .022.04l.016.036q.013.016.019.038.005.022.018.038l.028.038q.015.022.029.038l.028.038.028.038a.25.25 0 0 0 .094.104l.037.029.038.028.037.028q.015.015.038.029l.037.029a.1.1 0 0 0 .04.022l.035.015c.019.02.038.038.075.038q.011.001.025.007.017.01.05.012a.17.17 0 0 0 .094.02m-12.581-.001H51.8c.488 0 .9-.398.9-.91a.894.894 0 0 0-.9-.911h-9.262c-.507 0-.9.398-.9.91 0 .513.393.911.9.911" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M58.963 13.101c1.743.057 3.093 1.423 3.037 3.018a1433 1433 0 0 1-2.325 31.444q-.176 2.209-.356 4.397v.005c-.721 8.815-1.423 17.397-1.407 26.188-.018 1.67-1.237 3.036-2.756 3.036H9.07c-1.575-.076-2.907-1.575-2.963-3.32-.2-3.945-.369-7.746-.534-11.46-.3-6.739-.587-13.192-1.022-19.7-.355-5.597-.816-11.235-1.28-16.924-.369-4.515-.74-9.063-1.064-13.647A2.995 2.995 0 0 1 5.225 13.1zm-53.738 2.43c-.229 0-.375.1-.439.143l-.011.008a.6.6 0 0 0-.169.36c.158 2.196.325 4.4.496 6.59 1.137.265 11.54 2.639 18.836 2.728 3.984.051 10.378-.567 15.935-1.105 2.705-.261 5.212-.504 7.146-.64 6.431-.448 11.211.557 12.04.747q.284-4.16.541-8.357 0-.114-.113-.228a.87.87 0 0 0-.58-.247z"
				/>
			</g>
			<rect
				id="qr-background"
				x={12.5}
				y={29}
				width={39}
				height={39}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 17,
							y: 33.5,
							width: 30,
							height: 30,
						}),
					}}
				/>
			) : (
				<MockQr x={17} y={33.5} width={30} height={30} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
